import React from 'react';
import { Paper, Box, Typography, Stack } from '@mui/material';
import { AutoAwesome as AutoIcon, CheckCircle as CheckIcon } from '@mui/icons-material';
import { formatCurrency } from '../../../helpers/formatCurrency';

const AutoInfoSection = ({
  isBulkMode,
  currentTransactions,
  entryType,
  allPositive,
  formData,
  availableBankAccounts,
  selectedStatement,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
        border: '1px solid',
        borderColor: 'info.light',
      }}
    >
      <Box display="flex" alignItems="flex-start" gap={1.5}>
        <Box
          sx={{
            backgroundColor: 'info.main',
            borderRadius: 2,
            p: 0.75,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mt: 0.25,
          }}
        >
          <AutoIcon sx={{ color: 'white', fontSize: 20 }} />
        </Box>
        <Box flex={1}>
          <Typography variant="subtitle2" fontWeight="600" color="info.dark" gutterBottom>
            Campos Preenchidos Automaticamente
          </Typography>
          <Typography variant="body2" color="info.dark" component="div">
            {isBulkMode ? (
              <Stack spacing={0.5}>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckIcon sx={{ fontSize: 16 }} />
                  <span>{currentTransactions.length} lançamentos serão criados</span>
                </Box>
                {entryType === 'transfer' && (
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <CheckIcon sx={{ fontSize: 16 }} />
                    <span>Cada transação gerará 2 lançamentos vinculados (entrada e saída)</span>
                  </Box>
                )}
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckIcon sx={{ fontSize: 16 }} />
                  <span>
                    Cada lançamento terá valor, data e tipo baseados na transação correspondente
                  </span>
                </Box>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckIcon sx={{ fontSize: 16 }} />
                  <span>Conta bancária: {selectedStatement?.bankName || 'Conta do extrato'}</span>
                </Box>
                {entryType === 'transfer' && formData.targetBankAccountId && (
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <CheckIcon sx={{ fontSize: 16 }} />
                    <span>
                      Conta {allPositive ? 'de origem' : 'de destino'}:{' '}
                      {availableBankAccounts.find((acc) => acc.id === formData.targetBankAccountId)
                        ?.name || 'Conta selecionada'}
                    </span>
                  </Box>
                )}
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckIcon sx={{ fontSize: 16 }} />
                  <span>Todos os lançamentos serão automaticamente conciliados</span>
                </Box>
              </Stack>
            ) : (
              <Stack spacing={0.5}>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckIcon sx={{ fontSize: 16 }} />
                  <span>Valor: {formatCurrency(Math.abs(currentTransactions[0].amount))}</span>
                </Box>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckIcon sx={{ fontSize: 16 }} />
                  <span>
                    Data: {new Date(currentTransactions[0].datePosted).toLocaleDateString('pt-BR')}
                  </span>
                </Box>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckIcon sx={{ fontSize: 16 }} />
                  <span>Conta bancária: {selectedStatement?.bankName || 'Conta do extrato'}</span>
                </Box>
                {entryType === 'transfer' && (
                  <>
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <CheckIcon sx={{ fontSize: 16 }} />
                      <span>Tipo: Transferência (2 lançamentos vinculados)</span>
                    </Box>
                    {formData.targetBankAccountId && (
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <CheckIcon sx={{ fontSize: 16 }} />
                        <span>
                          Conta {allPositive ? 'de origem' : 'de destino'}:{' '}
                          {availableBankAccounts.find(
                            (acc) => acc.id === formData.targetBankAccountId
                          )?.name || 'Conta selecionada'}
                        </span>
                      </Box>
                    )}
                  </>
                )}
                {entryType === 'regular' && (
                  <Box display="flex" alignItems="center" gap={0.5}>
                    <CheckIcon sx={{ fontSize: 16 }} />
                    <span>Tipo: {currentTransactions[0].amount > 0 ? 'Entrada' : 'Saída'}</span>
                  </Box>
                )}
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckIcon sx={{ fontSize: 16 }} />
                  <span>O lançamento será automaticamente conciliado</span>
                </Box>
              </Stack>
            )}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default AutoInfoSection;
